export default __webpack_public_path__ + "static/media/sticker_phone.e0ab63fc.svg";